import displayError from '@/api/errors/errorResponse'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteDisplayService } from '@/api/services/displays/displaysService'
import { DialogDescription } from '@radix-ui/react-dialog'
import { Trash2 } from 'lucide-react'
import { useState } from 'react'

function DisplayDelete({ id }: { id: string }) {
  const [open, setOpen] = useState(false)

  const queryClient = useQueryClient()

  const { mutate } = useMutation({
    mutationFn: () => deleteDisplayService(id),
    onSuccess: async (res) => {
      if (!res.success) return displayError(res)
      setOpen(false)
      await queryClient.invalidateQueries({ queryKey: ['displays'] })
    }
  })

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button
          className="flex flex-row justify-between border-none shadow-none"
          variant={'ghost'}
        >
          Usuń
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby="Usuń wyświetlacz"
        aria-description="Usuń wyświetlacz"
      >
        <DialogHeader>
          <DialogTitle>Usuń wyświetlacz</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Czy na pewno chcesz usunąć ten wyświetlacz? Ta operacja jest nieodwracalna.
        </DialogDescription>
        <div className="flex w-full flex-row justify-end gap-4">
          <Button
            onClick={() => {
              setOpen(false)
            }}
            variant="outline"
          >
            Anuluj
          </Button>
          <Button
            onClick={() => {
              mutate()
            }}
            variant="destructive"
          >
            Usuń
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DisplayDelete
